import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Mic, Mail, ShoppingBag, Users, UserPlus, UsersRound, Newspaper, Menu, X } from 'lucide-react';

const Sidebar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { path: '/', label: 'Home', icon: Home },
    { path: '/podcast', label: 'Podcast', icon: Mic },
    { path: '/about', label: 'About Us', icon: Users },
    { path: '/merchandise', label: 'Shop', icon: ShoppingBag },
    { path: '/be-our-guest', label: 'Be Our Guest', icon: UserPlus },
    { path: '/community', label: 'Community', icon: UsersRound },
    { path: '/press', label: 'Media & Events', icon: Newspaper },
    { path: '/contact', label: 'Contact', icon: Mail },
  ];

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <>
      {/* Mobile Hamburger Button */}
      <button
        onClick={toggleMenu}
        className="fixed top-4 left-4 z-[60] lg:hidden w-12 h-12 rounded-lg flex items-center justify-center transition-all duration-300"
        style={{ backgroundColor: isOpen ? '#b76e79' : '#000' }}
      >
        {isOpen ? <X size={24} className="text-white" /> : <Menu size={24} className="text-white" />}
      </button>

      {/* Overlay for mobile */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={closeMenu}
        />
      )}

      {/* Sidebar */}
      <aside 
        className={`fixed left-0 top-0 h-screen w-64 bg-black text-white flex flex-col z-50 transition-transform duration-300 lg:translate-x-0 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="p-6 border-b border-gray-800">
          <Link to="/" onClick={closeMenu} className="block">
            <img 
              src="https://customer-assets.emergentagent.com/job_sleek-latina-site/artifacts/hwczxv2r_dbl%20logo.jpg" 
              alt="Dos Bold Latinas Logo" 
              className="w-20 h-20 mx-auto mb-4 rounded-full object-cover"
            />
            <h1 className="text-2xl font-bold text-center" style={{ fontFamily: 'Georgia, serif' }}>
              Dos Bold
              <br />
              <span style={{ color: '#b76e79' }}>Latinas</span>
            </h1>
          </Link>
        </div>

        <nav className="flex-1 px-4 py-8 overflow-y-auto">
          <ul className="space-y-2">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    onClick={closeMenu}
                    className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-300 ${
                      isActive
                        ? 'bg-rose-900/30 text-white shadow-lg border-l-4'
                        : 'text-gray-300 hover:bg-gray-900 hover:text-white'
                    }`}
                    style={isActive ? { borderLeftColor: '#b76e79' } : {}}
                  >
                    <Icon size={20} />
                    <span className="font-medium">{item.label}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

        <div className="p-6 border-t border-gray-800">
          <p className="text-xs text-gray-400 text-center">
            © 2025 Dos Bold Latinas
            <br />
            All rights reserved
          </p>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;